import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CookieSettings } from '../components/CookieSettings';
export function DatenschutzPage() {
  const [showCookieSettings, setShowCookieSettings] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleCookieSave = (preferences: {
    necessary: boolean;
    analytics: boolean;
    marketing: boolean;
  }) => {
    const prefs = {
      ...preferences,
      timestamp: Date.now()
    };
    localStorage.setItem('vitafrukt-cookie-consent', JSON.stringify(prefs));
    setShowCookieSettings(false);
  };
  return <>
      <section className="py-16 md:py-24 bg-white" data-id="element-345">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-346">
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-vita-green-deep mb-12" data-id="element-347">
            Datenschutzerklärung
          </h1>

          <div className="space-y-10 text-vita-text-muted leading-relaxed" data-id="element-348">
            <div data-id="element-349">
              <h2 className="font-heading text-xl font-bold text-vita-text mb-3" data-id="element-350">
                1. Verantwortliche Stelle
              </h2>
              <p data-id="element-351">
                Verantwortlich für die Datenverarbeitung auf dieser Website ist:
              </p>
              <p className="mt-4" data-id="element-352">
                Nuviora UG (haftungsbeschränkt) Cosimastraße 121 München, 81925
                Deutschland E-Mail: info@vitafrukt.de
              </p>
            </div>

            <div data-id="element-353">
              <h2 className="font-heading text-xl font-bold text-vita-text mb-3" data-id="element-354">
                2. Erhebung und Speicherung personenbezogener Daten
              </h2>
              <p data-id="element-355">
                Beim Besuch unserer Website werden automatisch Informationen
                durch den Browser übermittelt und in sogenannten
                Server-Log-Dateien gespeichert. Dies umfasst Browsertyp und
                -version, verwendetes Betriebssystem, Referrer URL, Hostname des
                zugreifenden Rechners, Uhrzeit der Serveranfrage und die
                IP-Adresse.
              </p>
              <p className="mt-4" data-id="element-356">
                Diese Daten sind nicht bestimmten Personen zuordenbar. Eine
                Zusammenführung dieser Daten mit anderen Datenquellen wird nicht
                vorgenommen. Wir behalten uns vor, diese Daten nachträglich zu
                prüfen, wenn uns konkrete Anhaltspunkte für eine rechtswidrige
                Nutzung bekannt werden.
              </p>
            </div>

            <div data-id="element-357">
              <h2 className="font-heading text-xl font-bold text-vita-text mb-3" data-id="element-358">
                3. Cookies
              </h2>
              <p data-id="element-359">
                Unsere Website verwendet Cookies. Cookies sind kleine
                Textdateien, die auf deinem Endgerät gespeichert werden und die
                dein Browser speichert. Sie dienen dazu, unser Angebot
                nutzerfreundlicher und effektiver zu machen.
              </p>
              <p className="mt-4" data-id="element-360">
                Wir unterscheiden zwischen notwendigen Cookies, die für die
                Grundfunktionen der Website erforderlich sind, Analyse-Cookies,
                die uns helfen, die Nutzung der Website zu verstehen, und
                Marketing-Cookies.
              </p>
              <p className="mt-4" data-id="element-361">
                Du kannst deine Cookie-Einstellungen jederzeit anpassen:
              </p>
              <button onClick={() => setShowCookieSettings(true)} className="mt-4 inline-flex items-center px-5 py-2.5 bg-vita-green-deep text-white font-medium rounded-full hover:bg-vita-green-medium transition-colors text-sm" data-id="element-362">
                Cookie-Einstellungen öffnen
              </button>
            </div>

            <div data-id="element-363">
              <h2 className="font-heading text-xl font-bold text-vita-text mb-3" data-id="element-364">
                4. Analyse-Tools
              </h2>
              <p data-id="element-365">
                Wir nutzen ggf. Analyse-Tools, um das Nutzungsverhalten auf
                unserer Website statistisch auszuwerten. Die dabei gewonnenen
                Daten werden nicht dazu verwendet, den Besucher dieser Website
                persönlich zu identifizieren, und werden nicht mit
                personenbezogenen Daten zusammengeführt. Die Nutzung dieser
                Tools erfolgt nur mit deiner Einwilligung.
              </p>
            </div>

            <div data-id="element-366">
              <h2 className="font-heading text-xl font-bold text-vita-text mb-3" data-id="element-367">
                5. Newsletter
              </h2>
              <p data-id="element-368">
                Wenn du unseren Newsletter abonnierst, wird deine E-Mail-Adresse
                für den Versand des Newsletters gespeichert. Du kannst den
                Newsletter jederzeit über den Abmeldelink in jeder E-Mail oder
                per Nachricht an uns abbestellen. Nach der Abmeldung wird deine
                E-Mail-Adresse gelöscht.
              </p>
            </div>

            <div data-id="element-369">
              <h2 className="font-heading text-xl font-bold text-vita-text mb-3" data-id="element-370">
                6. Deine Rechte
              </h2>
              <p data-id="element-371">Du hast jederzeit das Recht auf:</p>
              <ul className="mt-4 space-y-2 ml-4" data-id="element-372">
                <li className="flex items-start" data-id="element-373">
                  <span className="w-1.5 h-1.5 rounded-full bg-vita-green-sage mt-2 mr-3 flex-shrink-0" data-id="element-374"></span>
                  <span data-id="element-375">
                    <span className="font-medium text-vita-text" data-id="element-376">Auskunft</span>{' '}
                    über deine bei uns gespeicherten personenbezogenen Daten
                  </span>
                </li>
                <li className="flex items-start" data-id="element-377">
                  <span className="w-1.5 h-1.5 rounded-full bg-vita-green-sage mt-2 mr-3 flex-shrink-0" data-id="element-378"></span>
                  <span data-id="element-379">
                    <span className="font-medium text-vita-text" data-id="element-380">
                      Berichtigung
                    </span>{' '}
                    unrichtiger personenbezogener Daten
                  </span>
                </li>
                <li className="flex items-start" data-id="element-381">
                  <span className="w-1.5 h-1.5 rounded-full bg-vita-green-sage mt-2 mr-3 flex-shrink-0" data-id="element-382"></span>
                  <span data-id="element-383">
                    <span className="font-medium text-vita-text" data-id="element-384">Löschung</span>{' '}
                    deiner bei uns gespeicherten Daten
                  </span>
                </li>
                <li className="flex items-start" data-id="element-385">
                  <span className="w-1.5 h-1.5 rounded-full bg-vita-green-sage mt-2 mr-3 flex-shrink-0" data-id="element-386"></span>
                  <span data-id="element-387">
                    <span className="font-medium text-vita-text" data-id="element-388">
                      Einschränkung
                    </span>{' '}
                    der Datenverarbeitung
                  </span>
                </li>
                <li className="flex items-start" data-id="element-389">
                  <span className="w-1.5 h-1.5 rounded-full bg-vita-green-sage mt-2 mr-3 flex-shrink-0" data-id="element-390"></span>
                  <span data-id="element-391">
                    <span className="font-medium text-vita-text" data-id="element-392">
                      Widerspruch
                    </span>{' '}
                    gegen die Verarbeitung deiner Daten
                  </span>
                </li>
                <li className="flex items-start" data-id="element-393">
                  <span className="w-1.5 h-1.5 rounded-full bg-vita-green-sage mt-2 mr-3 flex-shrink-0" data-id="element-394"></span>
                  <span data-id="element-395">
                    <span className="font-medium text-vita-text" data-id="element-396">
                      Datenübertragbarkeit
                    </span>{' '}
                    in einem gängigen Format
                  </span>
                </li>
              </ul>
            </div>

            <div data-id="element-397">
              <h2 className="font-heading text-xl font-bold text-vita-text mb-3" data-id="element-398">
                7. Kontakt für Datenschutzanfragen
              </h2>
              <p data-id="element-399">
                Bei Fragen zum Datenschutz kannst du dich jederzeit an uns
                wenden:
              </p>
              <p className="mt-4" data-id="element-400">
                E-Mail: info@vitafrukt.de Nuviora UG (haftungsbeschränkt)
                Cosimastraße 121 München, 81925 Deutschland
              </p>
            </div>

            <div className="pt-6 border-t border-vita-border text-sm text-vita-text-light" data-id="element-401">
              <p data-id="element-402"></p>
            </div>
          </div>
        </motion.div>
      </section>

      <CookieSettings isOpen={showCookieSettings} onClose={() => setShowCookieSettings(false)} onSave={handleCookieSave} data-id="element-403" />
    </>;
}